<template>
  <div>
    <div class="page-titles">
      <div class="col-md-5 align-self-center">
        <h4 class="text-themecolor">
          Khảo sát
        </h4>
      </div>
    </div>
    <div>
      Comming soon...
    </div>
  </div>
  </template>
  
<script>
  import { mapGetters, mapActions } from "vuex";

  export default {
    name: 'Survey',
    components: {

    },
    data() {
      return {}
    },
    computed: {
      ...mapGetters({
        
      })
    },

    methods: {
      ...mapActions({
        
      }),
      
    }
  }
  </script>
  
<style scoped>

</style>